const awardsImg = [...Array(32)].map((_, index) => ({
  imgPath: `https://budgitawards.s3.eu-west-2.amazonaws.com/2023_awards/img_${
    index + 1
  }.JPG`,
}));

export default awardsImg;
